export enum ApiResultStatusCode {
  Success = 200,
  Error = 201,
  NeedOtpConfirmation = 205,
  PasswordExpired = 206,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  NotAcceptable = 406,
  OTPExpired = 203,
  UserNotFound = 204,
  CanNotDeleteReferenceFound = 208,
  DuplicateRecordFound = 207,
  NotDeleteRole = 234,
  NotDeleteLocation = 248,
  ConflictOccurredInDuration = 209,
  PrimaryContactAlreadyAvailable = 210,
  NoUnreadNotification = 211,
  TotalAmountChanges = 212,
  EmailSendError = 213,
  DraftPrescriptionsPending = 214,
  RequiredReLogin = 501,
}
